import React from 'react';

const AboutSystem = () => {
  return (
    <div>
      ＯｎｅＮＥＣ事業継続支援システムとは、 <br />
      ＮＥＣグループ内において大規模災害時に <br />
      情報を共有するためのシステムです。
      <br />
      <br />
      <b>システムに関するお問い合わせ</b>
      <br />
      ・<a href="https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91" target="_blank" rel="noopener noreferrer">ITサービスポータル</a>
      <br />
      <br />
    </div>
  );
};

export default AboutSystem;